/**
 * Pricing-related types shared between backend and frontend
 */

// ─── SPA enums ───────────────────────────────────────────────────────────────

export enum SpaQuoteType {
  ShipAndDebit = "ShipAndDebit",
  StandardSpa = "StandardSpa",
  Promotional = "Promotional",
  Other = "Other",
}

// ─── SPA Request enums ───────────────────────────────────────────────────────

export enum SpaRequestStatus {
  Draft = "draft",
  PendingApproval = "pending_approval",
  InProgress = "in_progress",
  Done = "done",
}

export enum SpaUrgency {
  Low = "low",
  Medium = "medium",
  High = "high",
}

export enum SpaChangeType {
  Margins = "margins",
  Dates = "dates",
  AddItems = "add_items",
}

// ─── Price sheet validation (existing) ───────────────────────────────────────

/**
 * Status of price validation check against ERP list price
 */
export enum PriceValidationStatus {
  /** PO price matches or exceeds list price */
  STANDARD_PRICE = "STANDARD_PRICE",
  /** PO price matches approved discount */
  APPROVED_DISCOUNT = "APPROVED_DISCOUNT",
  /** PO price below expected (discount or list) price */
  UNAPPROVED_DISCOUNT = "UNAPPROVED_DISCOUNT",
  /** No list price available from ERP */
  NO_LIST_PRICE = "NO_LIST_PRICE",
}

/**
 * Result of a price validation check for a line item
 */
export interface PriceValidationResult {
  /** Status of the price check */
  status: PriceValidationStatus;
  /** Unit price from the purchase order */
  poUnitPrice: number;
  /** List price from ERP, null if not available */
  listPrice: number | null;
  /** Currency code from ERP, null if not available */
  currencyCode: string | null;
  /** Name of the price list used, null if not available */
  priceListName: string | null;
  /** Item number/SKU used for the query */
  itemNumber: string | null;
  /** Error message if the check failed */
  errorMessage?: string;
}
